import  { useEffect, useState } from "react";

import { useGetLeagueGroubMatchesQuery } from "../../lib/redux/services/Api";
import { useNavigate, useParams } from "react-router-dom";
import QuarterMap from "../../components/league-tournament/QuarterMapPage";
import SimiFinal from "../../components/league-tournament/SimiFinal";
import Loader from "../../components/skeletons/Loader";
import RoundOf16 from "../../components/league-tournament/charts/league/RoundOf16";
import RoundOf32 from "../../components/league-tournament/charts/league/RoundOf32";
import RoundOf8 from "../../components/league-tournament/charts/league/RoundOf8";
type Props = {
  type: "leagues" | "tournaments";
  isShareMode?:boolean
};

function FinalMapPage({ type,isShareMode=false }: Props) {
  const { id } = useParams();
  const [groupedMatches, setGroupedMatches] = useState<{ [key: string]: any }>(
    {}
  );
  const [generalINfo, setGeneralInfo] = useState<any>({});
  const { data: matches, isFetching } = useGetLeagueGroubMatchesQuery({
    id: id,
    stage: "knockouts",
  });
  useEffect(() => {
    // Reshape the data on component mount
    if (matches?.data) {
      const grouped = matches?.data.knockouts.reduce((acc: any, match: any) => {
        if (!acc[match.stage]) {
          acc[match.stage] = [];
        }
        acc[match.stage].push(match);
        return acc;
      }, {});
      console.log(grouped);
      setGeneralInfo({
        court: matches?.data.knockouts[0].court,
        sponsor_ids: matches?.data?.sponsor_ids,
        tournament_type: matches?.data?.tournament_type || "",
        poster_url: matches?.data.knockouts[0]?.poster_url || "",
        club_id: matches?.data?.club_id,
      });

      setGroupedMatches(grouped);
    }
  }, [matches]);
  if (isFetching) {
    return (
      <div className="w-full h-dvh flex  flex-col  bg-white justify-center items-center">
        <Loader />
      </div>
    );
  }
 const  generateMap =()=>{
  if(groupedMatches["Knockouts 2"] &&
        groupedMatches["Knockouts 2"].length > 0 ){
           return  <RoundOf32
            groupedMatches={groupedMatches}
            type={type}
            generalINfo={generalINfo}
            isShareMode={isShareMode}
           
          />
        }
        if(groupedMatches["Knockouts 1"] &&
        groupedMatches["Knockouts 1"].length > 0 ){
           return  <RoundOf16
            groupedMatches={groupedMatches}
            type={type}
            generalINfo={generalINfo}
            isShareMode={isShareMode}
            
          />
        }
    if(groupedMatches["Quarter Final"] &&
        groupedMatches["Quarter Final"].length > 0 ){
           return  <RoundOf8
            groupedMatches={groupedMatches}
            type={type}
            generalINfo={generalINfo}
            isShareMode={isShareMode}
          />
        }

    if (groupedMatches["Semi Final"] &&
        groupedMatches["Semi Final"].length > 0){
         return <SimiFinal
            groupedMatches={groupedMatches}
            type={type}
            isShareMode={isShareMode}
            generalINfo={generalINfo}
          />
        }
 }

  return (
    <>
      {matches?.data &&
        Object.keys(groupedMatches).length > 0 &&
        generateMap()}
      {/* {matches?.data && groupedMatches['Quarter Final'] && groupedMatches['Quarter Final'].length >0 ? <QuarterMap groupedMatches={groupedMatches}/>:<SimiFinal groupedMatches={groupedMatches}/>} */}
    </>
  );
}

export default FinalMapPage;
